// 9 Animal Health Solution categories for the homepage and Solutions page.
// All image URLs below have been individually verified to depict animal-health,
// veterinary, livestock, poultry or farm content. NO human-medical imagery.

// --- Verified-animal Pexels image pool used across the site ---
// 3152331  East-African farmer guiding cattle at golden hour
// 422218   Holstein-Friesian dairy cows in pasture (sunset)
// 735968   Beef cattle close-up in a field
// 162240   Brown cow with ear-tag in a green pasture
// 37748139 Mixed flock of chickens / family feeding poultry
// 1300357  Young duckling swimming
// 1300355  Group of ducklings huddled together
// 6235241  Veterinarian using a stethoscope on a German Shepherd
// 6235117  Veterinarian and assistant examining a cat in clinic
// 1108099  Two Golden Retriever puppies in grass
// 2933243  Green tractor plowing a field (mechanised agriculture)

export const SOLUTIONS = [
  {
    id: "poultry",
    title: "Poultry Health Solutions",
    blurb:
      "Day-1 chick support, respiratory and bacterial control, dewormers, growth, layer and broiler nutrition for poultry farmers and vet professionals.",
    products: [
      "BIOTRIM VET ORAL POWDER",
      "BIOTRIM VET PLUS ORAL POWDER",
      "LEVAZAN POULTRY",
      "Bio-Start",
      "BIOMIX BROILER BOOSTER",
      "BIOMIX Extra Egg",
    ],
    image:
      "https://images.pexels.com/photos/37748139/pexels-photo-37748139.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    species: ["poultry"],
    challenges: ["respiratory", "growth", "stress"],
  },
  {
    id: "dewormers",
    title: "Livestock Deworming & Parasite Control",
    blurb:
      "Broad-spectrum anthelmintics for cattle, camels, sheep and goats — including liver-fluke combinations and value Levamisole formulations.",
    products: [
      "WORMIZAN PLUS",
      "WORMIZAN SUPER",
      "LEVAZAN LIQUID DEWORMER",
      "ABEZOLE 2.5% W/V & 10% W/V",
    ],
    image:
      "https://images.pexels.com/photos/735968/pexels-photo-735968.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    species: ["cattle", "sheep-goats", "camels"],
    challenges: ["worms"],
  },
  {
    id: "nutrition",
    title: "Nutrition, Recovery & Productivity",
    blurb:
      "Multivitamins, mineral supplements and stress-recovery formulations to keep animals productive and resilient.",
    products: [
      "VitaVet WS",
      "Di-Calcium Phosphate (DCP)",
      "BIOMIX ANTISTRESS",
      "BIOMIX NUTRIGOLD",
    ],
    image:
      "https://images.pexels.com/photos/1300355/pexels-photo-1300355.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    species: ["cattle", "poultry", "sheep-goats"],
    challenges: ["stress", "growth"],
  },
  {
    id: "antibiotics",
    title: "Antibiotic / Antimicrobial Product Range",
    blurb:
      "Respiratory, bacterial and combination antimicrobials for clinic and field use across species. For prescription and veterinary supervision.",
    products: [
      "DOXY-TYL VET POWDER",
      "BIOTRIM VET ORAL POWDER",
      "BIOTET",
      "Gendex",
    ],
    image:
      "https://images.pexels.com/photos/6235241/pexels-photo-6235241.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    species: ["cattle", "poultry", "pigs"],
    challenges: ["respiratory"],
  },
  {
    id: "udder",
    title: "Udder & Dairy Support",
    blurb:
      "Protect teats, prevent mastitis and support clean milking with field-proven dairy support products.",
    products: ["Biosalve Medicated Milking Salve", "Biodine", "Cloben G Vet Cream"],
    image:
      "https://images.pexels.com/photos/422218/pexels-photo-422218.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    species: ["cattle"],
    challenges: ["udder"],
  },
  {
    id: "biosecurity",
    title: "Biosecurity & Disinfection",
    blurb:
      "Footbaths, fumigation, clinic and equipment disinfection — protect farms, hatcheries, clinics and supply chains.",
    products: ["OMNICIDE", "Kleenol", "Hycolin", "Peuritol Professional Hand Sanitizer"],
    image:
      "https://images.pexels.com/photos/162240/bull-calf-heifer-ko-162240.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    species: ["biosecurity"],
    challenges: ["biosecurity"],
  },
  {
    id: "companion",
    title: "Companion Animal Care",
    blurb:
      "Broad-spectrum dog deworming, joint support and small-animal solutions for clinics and pet caregivers.",
    products: ["POPVET TOTAL", "JointGuard — Cats & Dogs"],
    image:
      "https://images.pexels.com/photos/1108099/pexels-photo-1108099.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    species: ["dogs-cats"],
    challenges: ["worms", "stress"],
  },
  {
    id: "instruments",
    title: "Veterinary Instruments",
    blurb:
      "Castration, identification, dosing, hoof, calving, milking, sheep/goat and small-animal instruments — sourced for East African field conditions.",
    products: [
      "Burdizzo Castration Forceps",
      "Balling Guns",
      "Hoof Knives",
      "Calving Forceps",
      "Ear Notchers",
    ],
    image:
      "https://images.pexels.com/photos/6235117/pexels-photo-6235117.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    species: ["biosecurity"],
    challenges: ["handling"],
  },
  {
    id: "cold-chain",
    title: "Vaccine Cold Chain & Carriers",
    blurb:
      "Vaccine refrigerators, field carriers and electronic temperature loggers for clinics, institutions and outreach campaigns.",
    products: [
      "Haier HYC-68A",
      "Haier HZY-15Z",
      "Haier HZY-8Z",
      "Haier HZY-5B",
      "Haier HZY-35B",
      "Haier Electronic Temperature Logger",
    ],
    image:
      "https://images.pexels.com/photos/1300357/pexels-photo-1300357.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    species: ["cold-chain"],
    challenges: ["cold-storage"],
  },
];

export const RESPONSIBILITY_PILLARS = [
  {
    id: "responsibility",
    eyebrow: "Responsibility",
    title: "Every treatment decision matters.",
    front_lede:
      "Supporting animal welfare, farmer livelihoods and responsible use.",
    body:
      "Biodeal Animal Health supports animal welfare, farmer livelihoods, food security and responsible product use — in every farm, agrovet and clinic we serve.",
    // Flip-card assets, focal points & short back-face content
    front_image: "/pillars/responsibility-front.webp",
    front_position: "50% 22%",
    front_alt:
      "Biodeal Animal Health veterinarian in a poultry house examining a hen with a stethoscope.",
    back_image: "/pillars/responsibility-back.webp",
    back_position: "50% 32%",
    back_alt:
      "Veterinary professional carrying out a clinical examination — demonstrating responsible field-level animal care.",
    back_heading: "Responsibility from clinic to farm gate.",
    back_bullets: [
      "Vet-led practice",
      "Responsible product use",
      "Animal welfare first",
    ],
    cta_label: "Read About Responsibility",
    cta_to: "/about#responsibility",
  },
  {
    id: "innovation",
    eyebrow: "Innovation",
    title: "Solutions built for real field conditions.",
    front_lede:
      "Medicines, instruments and cold-chain — engineered for East African farms.",
    body:
      "Medicines, instruments and cold-chain support designed for East African farms, agrovets, clinics and outreach campaigns — not generic catalogue products.",
    front_image: "/pillars/innovation-front.jpg",
    front_position: "50% 30%",
    front_alt:
      "Biodeal production supervisor in a hard-hat inside the manufacturing facility, in front of stainless-steel process equipment.",
    back_image: "/pillars/innovation-back.png",
    back_position: "50% 35%",
    back_alt:
      "Biodeal production operator at the plant control panel, monitoring the manufacturing process.",
    back_heading: "Manufactured for East African conditions.",
    back_bullets: [
      "Made in Kenya",
      "Field-tested formulations",
      "Complete ecosystem",
    ],
    cta_label: "Read About Innovation",
    cta_to: "/about#innovation",
  },
  {
    id: "trust",
    eyebrow: "Trust",
    title: "Built on Biodeal experience.",
    front_lede:
      "Field-tested products backed by a team that shows up on farms.",
    body:
      "Local field understanding, technical and veterinary support, and a commitment to farmers — that is how Biodeal Animal Health builds long-term trust.",
    front_image: "/pillars/trust-front.png",
    front_position: "38% 45%",
    front_alt:
      "Customer at a Biodeal Animal Health stand handling a product from the Biosalve, BIOMIX and Bio-Start range.",
    back_image: "/pillars/trust-back.jpeg",
    back_position: "50% 40%",
    back_alt:
      "Biodeal Animal Health field team engaging a farmer at a demonstration stand under a Biodeal-branded tent.",
    back_heading: "Trust that shows up on farms.",
    back_bullets: [
      "Field support",
      "Technical team on the ground",
      "Farmer partnership",
    ],
    cta_label: "Read About Trust",
    cta_to: "/about#trust",
  },
];

export const AUDIENCES = [
  {
    id: "vets",
    title: "Veterinary Professionals",
    blurb:
      "Technical product support, practical field solutions, instruments and training for responsible animal health practice.",
    cta_label: "Enter Vet Professionals",
    cta_to: "/vet-professionals",
    image:
      "https://images.pexels.com/photos/6235241/pexels-photo-6235241.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "farmers",
    title: "Farmers & Livestock Producers",
    blurb:
      "Practical solutions that support healthier animals, better productivity and stronger livelihoods.",
    cta_label: "Find the Right Solution",
    cta_to: "/products",
    image:
      "https://images.pexels.com/photos/3152331/pexels-photo-3152331.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "companion",
    title: "Companion Animals",
    blurb:
      "Approved companion-animal products from the Biodeal range — for dog and cat caregivers, veterinary-led guidance.",
    cta_label: "Explore Companion Range",
    cta_to: "/products?species=dogs-cats",
    image:
      "https://images.pexels.com/photos/1108099/pexels-photo-1108099.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "partners",
    title: "Business & Partners",
    blurb:
      "Stockists, distributors, institutions and international partners — apply to work with Biodeal Animal Health.",
    cta_label: "Partner With Biodeal",
    cta_to: "/become-a-stockist",
    image:
      "https://images.pexels.com/photos/422218/pexels-photo-422218.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export const FIELD_ACTIVITIES = [
  {
    id: "veterinary-training",
    label: "Veterinary training",
    image:
      "https://images.pexels.com/photos/6235241/pexels-photo-6235241.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=820&w=820",
  },
  {
    id: "farm-visits",
    label: "Farm visits",
    image:
      "https://images.pexels.com/photos/3152331/pexels-photo-3152331.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=820&w=820",
  },
  {
    id: "agrovet-education",
    label: "Agrovet education",
    image:
      "https://images.pexels.com/photos/2933243/pexels-photo-2933243.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=820&w=820",
  },
  {
    id: "product-demos",
    label: "Product demonstrations",
    image:
      "https://images.pexels.com/photos/6235117/pexels-photo-6235117.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=820&w=820",
  },
  {
    id: "poultry-support",
    label: "Poultry support",
    image:
      "https://images.pexels.com/photos/37748139/pexels-photo-37748139.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=820&w=820",
  },
  {
    id: "dairy-support",
    label: "Dairy & livestock support",
    image:
      "https://images.pexels.com/photos/422218/pexels-photo-422218.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=820&w=820",
  },
  {
    id: "biosecurity-support",
    label: "Biosecurity support",
    image:
      "https://images.pexels.com/photos/162240/bull-calf-heifer-ko-162240.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=820&w=820",
  },
  {
    id: "instrument-demos",
    label: "Instrument demonstrations",
    image:
      "https://images.pexels.com/photos/6235117/pexels-photo-6235117.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=820&w=820",
  },
];
